import {
  PROJECT_STATUS_CANCELLED,
  PROJECT_STATUS_DELIVERED,
  PROJECT_STATUS_QUALIFIED,
  STATUSES_OBJ,
} from './statuses/constants';

export const ACCOUNTABLE_LIST = [
  'AM',
  'Business Navigation',
  'Business owner',
  'Centres Digital',
  'CFF',
  'Communication & Interior Design',
  'Customer Experience',
  'Digital',
  'Ingka Food',
  'Logistics',
  'Meeting place',
  'People & Culture',
  'Procurement',
  'Real Estate',
  'Risk & Compliance',
  'Sustainability',
];

export const RESPONSIBLE_LIST = [
  'AM',
  'Cluster CPM',
  'Cluster ENG',
  'Cluster FM',
  'District FM',
  'External',
  'RED',
  'Site FM',
];

export const SOLUTION_PURPOSES = [
  'Business continuity',
  'Compliance',
  'costsavings',
  'Life cycle',
  'Sustainability',
];

export const SOLUTION_TYPES = [
  'AM',
  'BMS upgrade',
  'bmsUpgrade',
  'Commercial repairs',
  'Communication & Interior Design',
  'Customer Experience',
  'Digital',
  'Ecopilot 5S',
  'Energy Efficiency',
  'Energy enevelope facade',
  'Equipment replacement or upgrade',
  'EV chargers',
  'Facade repairs',
  'Flooring repairs',
  'Fuel Cell',
  'Generators',
  'HVAC',
  'LED 5S',
  'Legal or contractual',
  'Lightning (non LED)',
  'Meeting place',
  'Metering 5S',
  'Parking  Repairs',
  'Parking repairs',
  'People & Culture',
  'Photovoltaic panels',
  'Power Optimiser (E-Power) 5S',
  'Power optimiser (E-power)',
  'Procurement',
  'Public infrastructure intervention',
  'Real Estate',
  'RED',
  'Restrooms',
  'Risk & Compliance',
  'Roof repairs',
  'Safety and security',
  'Structural Upgrades and Repairs',
  'Sustainability',
  'Trade Dress replacement',
  'Waste baler',
  'Waste Balers 5S',
  'Waste Other',
  'Waste water management',
  'Water related systems',
];

export const PROJECT_PRIORITIES = ['critical', 'necessary', 'recommended'];

export const FYS = [
  'FY22',
  'FY23',
  'FY24',
  'FY25',
  'FY26',
  'FY27',
  'FY28',
  'FY29',
  'FY30',
];

export const COUNTRIES = [
  'Asia Pacific',
  'China',
  'Europe Atlantic',
  'Europe Central',
  'Europe North',
  'Europe South & East',
  'India',
  'North America',
  'Russia',
];

export const ADDITIONAL_APPROVAL_OPTIONS = [
  'Business Case Approved',
  'IR approved',
  'Not Applicable / Business Case Approval not needed',
];

export const YEAR = 31536000000;

export const PORTFOLIO_THRESHOLD = 350000;

export const PROJECT_PAGE_COLUMN_SETTING = 'projectPageDatagridSetting';
export const FLIGHT_PAGE_COLUMN_SETTING = 'flightPageDatagridSettings';
export const ARCHIVE_PAGE_COLUMN_SETTING = 'archivePageDatagridSetting';
export const USERS_COLUMN_SETTING = 'usersDatagridSetting';

export const standardVisibleColumns = {
  businessUnitId: true,
  projectName: true,
  totalProjectInvestment: true,
  projectStartFiscalYear: true,
  projectCompletionFiscalYear: true,
  projectStatus: true,
  priority: true,
  mtoolId: true,
  __check__: true,
};

export const standardFlightVisibilityColumns = {
  businessUnitId: true,
  projectName: true,
  totalProjectInvestment: true,
  projectStatus: true,
  priority: true,
  projectStartFiscalYear: true,
  projectCompletionFiscalYear: true,
  __check__: true,
};
export const standardUserVisibilityColumns = {
  id: false,
  name: true,
  email: true,
  role: true,
  businessUnits: true,
  countries: true,
  clusters: true,
};
export const userVisibilityColumns = {
  id: false,
  name: false,
  email: false,
  role: false,
  businessUnits: false,
  countries: false,
  clusters: false,
};

export const standardDataGridColumns = {
  accountable: false,
  additionalProjectInformation: false,
  annualCostImpactNet: false,
  annualCostImpactNetEur: false,
  benefitsAndRisk: false,
  riskAvoidance: false,
  biofuelsNetKwh: false,
  boarded: false,
  budgeting: false,
  subcategory: false,
  countryName: false,
  businessUnitFullName: false,
  businessUnitId: false,
  cluster: false,
  co2e: false,
  co2eSociety: false,
  country: false,
  countryCode: false,
  cpmFm: false,
  currency: false,
  depreciation: false,
  depreciationAccount: false,
  depreciationAmount: false,
  depreciationEur: false,
  districtCoolingNetKwh: false,
  districtFm: false,
  districtHeatNetKwh: false,
  engineer: false,
  etrProjectId: false,
  etrSolutionId: false,
  etrUnitId: false,
  externalContractorsNeeded: false,
  gasNetKwh: false,
  generatedNetKwh: false,
  id: false,
  impactYear1: false,
  impactYear1Eur: false,
  landCost: false,
  landCostEur: false,
  legalUnit: false,
  mtoolId: false,
  operationalCost: false,
  operationalCostEur: false,
  paybackYrs: false,
  plImpact: false,
  plImpactAccount: false,
  plImpactAmountPerAccount: false,
  portfolio: false,
  potentialYearlyIncome: false,
  potentialYearlyIncomeEur: false,
  priority: false,
  projectAssets: false,
  projectCompletionDate: false,
  projectCompletionFiscalYear: false,
  projectName: false,
  projectStartDate: false,
  projectStartFiscalYear: false,
  projectStatus: false,
  propertyInvestment: false,
  propertyInvestmentEur: false,
  realEstateDevelopment: false,
  recurringYearlyOperationalCost: false,
  recurringYearlyOperationalCostEur: false,
  recurringYearlySavings: false,
  recurringYearlySavingsEur: false,
  referenceId: false,
  retailCost: false,
  retailCostEur: false,
  retailInvestment: false,
  retailInvestmentEur: false,
  solutionPurpose: false,
  solutionType: false,
  sustainId: false,
  totalElectricityNetKwh: false,
  totalProjectInvestment: false,
  totalProjectInvestmentEur: false,
  unifierId: false,
  unitCategory: false,
  unitFm: false,
  unitType: false,
  updatedAt: false,
  createdBy: false,
  wasteReductionT: false,
  waterReductionM3: false,
  localUniqueId: false,
  etrProjectExecutionStatus: false,
  __check__: false,
};

export const AVAILABLE_STATUS_CHANGE = [
  STATUSES_OBJ[PROJECT_STATUS_QUALIFIED],
  STATUSES_OBJ[PROJECT_STATUS_CANCELLED],
  STATUSES_OBJ[PROJECT_STATUS_DELIVERED],
];

export const COUNTRY_LONG_TERM_RATES = {
  AU: 0.04,
  AT: 0.03,
  BE: 0.03,
  CA: 0.035,
  CN: 0.05,
  HR: 0.04,
  CZ: 0.035,
  DK: 0.03,
  EE: 0.03,
  FI: 0.03,
  FR: 0.03,
  DE: 0.03,
  HU: 0.05,
  IN: 0.075,
  IE: 0.03,
  IT: 0.03,
  JP: 0.02,
  LV: 0.03,
  LT: 0.03,
  NL: 0.03,
  NZ: 0.04,
  NO: 0.035,
  PL: 0.04,
  PT: 0.03,
  RO: 0.05,
  RU: 0.08,
  RS: 0.06,
  SK: 0.03,
  SI: 0.03,
  KR: 0.045,
  ES: 0.03,
  SE: 0.03,
  CH: 0.03,
  UA: 0.11,
  GB: 0.035,
  US: 0.035,
};

export const PAYBACK_YEARS_INFINITY = 999999999;

export const LARGE_PROJECT_INVESTMENT = 350000;

export const SOURCE_CHANNELS = [
  {
    value: 'ishop',
    label: 'iSHOP',
  },
  {
    value: 'notNeededOther',
    label: 'Not needed / Others',
  },
  {
    value: 'procurmentCategory',
    label: 'Procurement Category Area Real Estate',
  },
];

export const TOOLTIP_SPAN_STYLE = {
  width: '100%',
  maxWidth: '22.5rem',
};

export const PRIVACY_POLICY_LINK =
  'https://inside.ingka.com/supportservices/Dataprivacy/Pages/Individual-rights.aspx';

export const LOCAL_DATA_PRIVACY_POLICY_LINK =
  'https://iweof.sharepoint.com/sites/sup/ais/SitePages/default_.aspx';

export const SUBMISSION_ACTIVE = 'Active';

export const ETR_STATUS_NOT_STARTED = 'NOT_STARTED';
export const ETR_STATUS_DRAFT = 'DRAFT';

export const UNIFIER_PROJECT_THRESHOLD = 1200000;

export const CO_2_ALLOWED_SOLUTION_TYPE = 'equipmentReplacementOrUpgrade';
export const CENTRAL_COOLING_SYSTEM_ID = '205807';
export const UPRIGHT_COOLERS_AND_FREEZERS_ID = '205809';
export const BLAST_CHILLERS_ID = '205812';
export const ICE_CREAM_MACHINE_ID = '205752';
export const OTHER_COOLING_EQUIPMENT_ID = '205813';
export const CO_2_ALLOWED_ASSETS_IDS_LIST = [
  CENTRAL_COOLING_SYSTEM_ID,
  UPRIGHT_COOLERS_AND_FREEZERS_ID,
  BLAST_CHILLERS_ID,
  ICE_CREAM_MACHINE_ID,
  OTHER_COOLING_EQUIPMENT_ID,
];
